import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const HEADER_STRINGS = appStrings.modules.lifeReadiness.header;

export const useAgentContext = (title: string, namesASubject: boolean) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Dashboard Header',
    description: namesASubject
      ? 'Page header naming whose Life Readiness is on screen, with description text and a banner card. The banner carries no button, so the quiz cannot be started from here.'
      : 'Page header with title, description text, and a CTA card prompting the user to start or continue the Life Readiness quiz.',
    detail: [title, HEADER_STRINGS.description].join('\n'),
  });
};
